<template>
  <div class="login-qr-code">
    <CommonImage v-if="qrDataUrl" :src="qrDataUrl" :width="size" :height="size" alt="QR Code" />
  </div>
</template>

<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    size?: number
    text?: string
  }>(),
  {
    size: 90,
    text: '',
  },
)

const qrDataUrl = ref('')
const QR_PIXEL_RATIO = 2

/** 生成二维码 data URL。 */
const generate = async (url: string) => {
  if (!url) return
  try {
    const qrModule = await import('qrcode')
    const QRCode = qrModule.default
    qrDataUrl.value = await QRCode.toDataURL(url, {
      width: props.size * QR_PIXEL_RATIO,
      margin: 0,
      color: { dark: '#000000', light: '#ffffff' },
      errorCorrectionLevel: 'H',
    })
  } catch (err) {
    // console.error('QRCode 生成异常:', err)
  }
}

/** 重置二维码（暴露给父组件调用）。 */
const setresetting = (url: string) => {
  generate(url)
}

watch(
  () => props.text,
  (value) => {
    if (value) generate(value)
  },
)

if (props.text) {
  await generate(props.text)
}

defineExpose({
  setresetting,
})
</script>

<style scoped lang="less">
.login-qr-code {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;

  img {
    display: block;
    image-rendering: pixelated;
  }
}
</style>
